/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './admin-login.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '@angular/common/src/location/location';
import * as import9 from '@angular/router/src/router';
import * as import10 from '../shared/auth.service';
import * as import11 from '@angular/core/src/metadata/view';
import * as import12 from '@angular/core/src/linker/component_factory';
import * as import13 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import14 from '@angular/core/src/linker/template_ref';
import * as import15 from '@angular/common/src/directives/ng_if';
import * as import16 from '../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import17 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import18 from '../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import19 from '../../../node_modules/@angular/forms/src/directives/validators.ngfactory';
import * as import20 from '../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import21 from '@angular/core/src/linker/element_ref';
import * as import22 from '@angular/forms/src/directives/default_value_accessor';
import * as import23 from '@angular/forms/src/directives/validators';
import * as import24 from '@angular/forms/src/validators';
import * as import25 from '@angular/forms/src/directives/control_value_accessor';
import * as import26 from '@angular/forms/src/directives/ng_model';
import * as import27 from '@angular/forms/src/directives/ng_control';
import * as import28 from '@angular/forms/src/directives/ng_control_status';
import * as import29 from '@angular/forms/src/directives/ng_form';
import * as import30 from '@angular/forms/src/directives/control_container';
export class Wrapper_AdminLoginComponent {
  context:import0.AdminLoginComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any) {
    this.changed = false;
    this.context = new import0.AdminLoginComponent(p0,p1,p2);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_AdminLoginComponent_Host:import2.RenderComponentType = (null as any);
class _View_AdminLoginComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _AdminLoginComponent_0_4:Wrapper_AdminLoginComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_AdminLoginComponent_Host0,renderType_AdminLoginComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'admin-logged-out',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_AdminLoginComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._AdminLoginComponent_0_4 = new Wrapper_AdminLoginComponent(this.parentInjector.get(import8.Location),this.parentInjector.get(import9.Router),this.parentInjector.get(import10.AuthService));
    this._appEl_0.initComponent(this._AdminLoginComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._AdminLoginComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.AdminLoginComponent) && (0 === requestNodeIndex))) { return this._AdminLoginComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AdminLoginComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._AdminLoginComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_AdminLoginComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_AdminLoginComponent_Host === (null as any))) { (renderType_AdminLoginComponent_Host = viewUtils.createRenderComponentType('',0,import11.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_AdminLoginComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const AdminLoginComponentNgFactory:import12.ComponentFactory<import0.AdminLoginComponent> = new import12.ComponentFactory<import0.AdminLoginComponent>('admin-logged-out',viewFactory_AdminLoginComponent_Host0,import0.AdminLoginComponent);
const styles_AdminLoginComponent:any[] = ([] as any[]);
var renderType_AdminLoginComponent:import2.RenderComponentType = (null as any);
class _View_AdminLoginComponent0 extends import1.AppView<import0.AdminLoginComponent> {
  _text_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _TemplateRef_15_5:any;
  _NgIf_15_6:import13.Wrapper_NgIf;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_AdminLoginComponent0,renderType_AdminLoginComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,parentRenderNode,'div',new import4.InlineArray4(4,'class','login-box','ng-controller','AdminLoginCtrl'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','login-logo logo-custum '),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n    GuernCMS\n  ',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_7 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','login-box-body'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n    ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_9,'p',new import4.InlineArray2(2,'class','login-box-msg'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'Connexion à l\'administration',(null as any));
    this._text_13 = this.renderer.createText(this._el_9,'\n\n        ',(null as any));
    this._text_14 = this.renderer.createText(this._el_9,'\n\n      ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_9,(null as any));
    this._appEl_15 = new import3.AppElement(15,9,this,this._anchor_15);
    this._TemplateRef_15_5 = new import14.TemplateRef_(this._appEl_15,viewFactory_AdminLoginComponent1);
    this._NgIf_15_6 = new import13.Wrapper_NgIf(this._appEl_15.vcRef,this._TemplateRef_15_5);
    this._text_16 = this.renderer.createText(this._el_9,'\n\n  ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_18 = this.renderer.createText(this._el_2,'\n',(null as any));
    this._text_19 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this.init(([] as any[]),[
      this._text_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import15.NgIf) && (15 === requestNodeIndex))) { return this._NgIf_15_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_15_0_0:any = this.context.credentials;
    this._NgIf_15_6.check_ngIf(currVal_15_0_0,throwOnChange,false);
    this._NgIf_15_6.detectChangesInInputProps(this,this._anchor_15,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_AdminLoginComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.AdminLoginComponent> {
  if ((renderType_AdminLoginComponent === (null as any))) { (renderType_AdminLoginComponent = viewUtils.createRenderComponentType('',0,import11.ViewEncapsulation.None,styles_AdminLoginComponent,{})); }
  return new _View_AdminLoginComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_AdminLoginComponent1 extends import1.AppView<any> {
  _el_0:any;
  _NgForm_0_3:import16.Wrapper_NgForm;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import17.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _DefaultValueAccessor_4_3:import18.Wrapper_DefaultValueAccessor;
  _RequiredValidator_4_4:import19.Wrapper_RequiredValidator;
  _NG_VALIDATORS_4_5:any[];
  _NG_VALUE_ACCESSOR_4_6:any[];
  _NgModel_4_7:import20.Wrapper_NgModel;
  _NgControl_4_8:any;
  _NgControlStatus_4_9:import17.Wrapper_NgControlStatus;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _DefaultValueAccessor_11_3:import18.Wrapper_DefaultValueAccessor;
  _RequiredValidator_11_4:import19.Wrapper_RequiredValidator;
  _NG_VALIDATORS_11_5:any[];
  _NG_VALUE_ACCESSOR_11_6:any[];
  _NgModel_11_7:import20.Wrapper_NgModel;
  _NgControl_11_8:any;
  _NgControlStatus_11_9:import17.Wrapper_NgControlStatus;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_AdminLoginComponent1,renderType_AdminLoginComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'form',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._NgForm_0_3 = new import16.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_0_4 = this._NgForm_0_3.context;
    this._NgControlStatusGroup_0_5 = new import17.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','form-group has-feedback'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'input',new import4.InlineArray16(10,'class','form-control','name','username','placeholder','Utilisateur','required','','type','text'),(null as any));
    this._DefaultValueAccessor_4_3 = new import18.Wrapper_DefaultValueAccessor(this.renderer,new import21.ElementRef(this._el_4));
    this._RequiredValidator_4_4 = new import19.Wrapper_RequiredValidator();
    this._NG_VALIDATORS_4_5 = [this._RequiredValidator_4_4.context];
    this._NG_VALUE_ACCESSOR_4_6 = [this._DefaultValueAccessor_4_3.context];
    this._NgModel_4_7 = new import20.Wrapper_NgModel(this._ControlContainer_0_4,this._NG_VALIDATORS_4_5,(null as any),this._NG_VALUE_ACCESSOR_4_6);
    this._NgControl_4_8 = this._NgModel_4_7.context;
    this._NgControlStatus_4_9 = new import17.Wrapper_NgControlStatus(this._NgControl_4_8);
    this._text_5 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_2,'span',new import4.InlineArray2(2,'class','glyphicon glyphicon-user form-control-feedback'),(null as any));
    this._text_7 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','form-group has-feedback'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n            ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_9,'input',new import4.InlineArray16(10,'class','form-control','name','password','placeholder','Mot de passe','required','','type','password'),(null as any));
    this._DefaultValueAccessor_11_3 = new import18.Wrapper_DefaultValueAccessor(this.renderer,new import21.ElementRef(this._el_11));
    this._RequiredValidator_11_4 = new import19.Wrapper_RequiredValidator();
    this._NG_VALIDATORS_11_5 = [this._RequiredValidator_11_4.context];
    this._NG_VALUE_ACCESSOR_11_6 = [this._DefaultValueAccessor_11_3.context];
    this._NgModel_11_7 = new import20.Wrapper_NgModel(this._ControlContainer_0_4,this._NG_VALIDATORS_11_5,(null as any),this._NG_VALUE_ACCESSOR_11_6);
    this._NgControl_11_8 = this._NgModel_11_7.context;
    this._NgControlStatus_11_9 = new import17.Wrapper_NgControlStatus(this._NgControl_11_8);
    this._text_12 = this.renderer.createText(this._el_9,'\n            ',(null as any));
    this._el_13 = import4.createRenderElement(this.renderer,this._el_9,'span',new import4.InlineArray2(2,'class','glyphicon glyphicon-lock form-control-feedback'),(null as any));
    this._text_14 = this.renderer.createText(this._el_9,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_16 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._text_18 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_16,'div',new import4.InlineArray2(2,'class','col-xs-4 pull-right'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_20,'\n            ',(null as any));
    this._el_23 = import4.createRenderElement(this.renderer,this._el_20,'button',new import4.InlineArray4(4,'class','btn btn-primary btn-block btn-flat btn-custom','type','submit'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'Valider',(null as any));
    this._text_25 = this.renderer.createText(this._el_20,'\n            ',(null as any));
    this._text_26 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._text_27 = this.renderer.createText(this._el_16,'\n        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'ngSubmit',this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_0,'submit',this.eventHandler(this._handle_submit_0_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_0,'reset',this.eventHandler(this._handle_reset_0_2.bind(this)));
    const subscription_0:any = this._NgForm_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_4,'ngModelChange',this.eventHandler(this._handle_ngModelChange_4_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_4,'input',this.eventHandler(this._handle_input_4_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_4,'blur',this.eventHandler(this._handle_blur_4_2.bind(this)));
    const subscription_1:any = this._NgModel_4_7.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_4_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_11,'ngModelChange',this.eventHandler(this._handle_ngModelChange_11_0.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_11,'input',this.eventHandler(this._handle_input_11_1.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_11,'blur',this.eventHandler(this._handle_blur_11_2.bind(this)));
    const subscription_2:any = this._NgModel_11_7.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_11_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8
    ]
    ,[
      subscription_0,
      subscription_1,
      subscription_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.DefaultValueAccessor) && (4 === requestNodeIndex))) { return this._DefaultValueAccessor_4_3.context; }
    if (((token === import23.RequiredValidator) && (4 === requestNodeIndex))) { return this._RequiredValidator_4_4.context; }
    if (((token === import24.NG_VALIDATORS) && (4 === requestNodeIndex))) { return this._NG_VALIDATORS_4_5; }
    if (((token === import25.NG_VALUE_ACCESSOR) && (4 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_4_6; }
    if (((token === import26.NgModel) && (4 === requestNodeIndex))) { return this._NgModel_4_7.context; }
    if (((token === import27.NgControl) && (4 === requestNodeIndex))) { return this._NgControl_4_8; }
    if (((token === import28.NgControlStatus) && (4 === requestNodeIndex))) { return this._NgControlStatus_4_9.context; }
    if (((token === import22.DefaultValueAccessor) && (11 === requestNodeIndex))) { return this._DefaultValueAccessor_11_3.context; }
    if (((token === import23.RequiredValidator) && (11 === requestNodeIndex))) { return this._RequiredValidator_11_4.context; }
    if (((token === import24.NG_VALIDATORS) && (11 === requestNodeIndex))) { return this._NG_VALIDATORS_11_5; }
    if (((token === import25.NG_VALUE_ACCESSOR) && (11 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_11_6; }
    if (((token === import26.NgModel) && (11 === requestNodeIndex))) { return this._NgModel_11_7.context; }
    if (((token === import27.NgControl) && (11 === requestNodeIndex))) { return this._NgControl_11_8; }
    if (((token === import28.NgControlStatus) && (11 === requestNodeIndex))) { return this._NgControlStatus_11_9.context; }
    if (((token === import29.NgForm) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._NgForm_0_3.context; }
    if (((token === import30.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._ControlContainer_0_4; }
    if (((token === import28.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._NgForm_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._DefaultValueAccessor_4_3.detectChangesInInputProps(this,this._el_4,throwOnChange);
    const currVal_4_1_0:any = '';
    this._RequiredValidator_4_4.check_required(currVal_4_1_0,throwOnChange,false);
    this._RequiredValidator_4_4.detectChangesInInputProps(this,this._el_4,throwOnChange);
    const currVal_4_2_0:any = 'username';
    this._NgModel_4_7.check_name(currVal_4_2_0,throwOnChange,false);
    const currVal_4_2_1:any = this.parent.context.credentials.username;
    this._NgModel_4_7.check_model(currVal_4_2_1,throwOnChange,false);
    this._NgModel_4_7.detectChangesInInputProps(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_9.detectChangesInInputProps(this,this._el_4,throwOnChange);
    this._DefaultValueAccessor_11_3.detectChangesInInputProps(this,this._el_11,throwOnChange);
    const currVal_11_1_0:any = '';
    this._RequiredValidator_11_4.check_required(currVal_11_1_0,throwOnChange,false);
    this._RequiredValidator_11_4.detectChangesInInputProps(this,this._el_11,throwOnChange);
    const currVal_11_2_0:any = 'password';
    this._NgModel_11_7.check_name(currVal_11_2_0,throwOnChange,false);
    const currVal_11_2_1:any = this.parent.context.credentials.password;
    this._NgModel_11_7.check_model(currVal_11_2_1,throwOnChange,false);
    this._NgModel_11_7.detectChangesInInputProps(this,this._el_11,throwOnChange);
    this._NgControlStatus_11_9.detectChangesInInputProps(this,this._el_11,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgForm_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._DefaultValueAccessor_4_3.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this._RequiredValidator_4_4.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this._NgModel_4_7.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_9.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this._DefaultValueAccessor_11_3.detectChangesInHostProps(this,this._el_11,throwOnChange);
    this._RequiredValidator_11_4.detectChangesInHostProps(this,this._el_11,throwOnChange);
    this._NgModel_11_7.detectChangesInHostProps(this,this._el_11,throwOnChange);
    this._NgControlStatus_11_9.detectChangesInHostProps(this,this._el_11,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgModel_4_7.context.ngOnDestroy();
    this._NgModel_11_7.context.ngOnDestroy();
  }
  private _handle_ngSubmit_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.login(this.parent.context.credentials)) !== false);
    return (true && pd_0_0);
  }
  private _handle_submit_0_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._NgForm_0_3.context.onSubmit($event)) !== false);
    return (true && pd_0_0);
  }
  private _handle_reset_0_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._NgForm_0_3.context.onReset()) !== false);
    return (true && pd_0_0);
  }
  private _handle_ngModelChange_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>(this.parent.context.credentials.username = $event)) !== false);
    return (true && pd_4_0);
  }
  private _handle_input_4_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this._DefaultValueAccessor_4_3.context.onChange($event.target.value)) !== false);
    return (true && pd_4_0);
  }
  private _handle_blur_4_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this._DefaultValueAccessor_4_3.context.onTouched()) !== false);
    return (true && pd_4_0);
  }
  private _handle_ngModelChange_11_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_11_0:any = ((<any>(this.parent.context.credentials.password = $event)) !== false);
    return (true && pd_11_0);
  }
  private _handle_input_11_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_11_0:any = ((<any>this._DefaultValueAccessor_11_3.context.onChange($event.target.value)) !== false);
    return (true && pd_11_0);
  }
  private _handle_blur_11_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_11_0:any = ((<any>this._DefaultValueAccessor_11_3.context.onTouched()) !== false);
    return (true && pd_11_0);
  }
}
function viewFactory_AdminLoginComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_AdminLoginComponent1(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-login.component.ngfactory.ts